/**
 * Get the base Uri for all API endpoints.
 * @returns {string} Uri to the front door, without trailing slash.
 */

export const getBaseEndpoint = (): string => {
  return window._env_.AFFILIATE_API_BASE_ENDPOINT
}

export const getCMSBaseEndpoint = (): string => {
  return window._env_.CARECONNECT_CMS_ENDPOINT
}

export const BASE_URL = getBaseEndpoint().replace("/api", "")
